import {
  formatPhoneNumberForTel,
  formatPin,
  formatPinForTel,
} from '../components/ScheduleMeetingModal/utils/dialInUtils';
import { getMeetingUrl } from './environment';
import { getDialInNumbersUrl } from './url';

export interface GetMeetingInvitationOptions {
  phoneNumber?: string | null;
  pin?: string | null;
  hasLicenseError?: boolean;
}

export function getMeetingInvitation(
  room: string,
  options?: GetMeetingInvitationOptions,
  password?: string,
): string {
  const { phoneNumber, pin, hasLicenseError } = options ?? {};

  const hasDialIn = !!phoneNumber || !!pin;
  const includeDialIn = hasDialIn && !hasLicenseError;

  const computerBlock = `
    🖥️ Join this meeting from your computer or mobile device:<br>
    <a href="${getMeetingUrl(room || '', password)}">${getMeetingUrl(room || '', password)}</a><br><br>
  `;

  const passwordBlock = includeDialIn && password ? ` | Password: ${password || ''}` : '';

  const dialInBlock = includeDialIn
    ? `
    📞 Want to join using a phone?<br>
    Dial-in: ${phoneNumber || ''} | PIN: ${formatPin(pin || '')}${passwordBlock}<br>
    [ tel:${formatPhoneNumberForTel(phoneNumber || '')},${formatPinForTel(pin || '')} ]<br><br>
  `
    : '';

  const dialInInfoUrl = getDialInNumbersUrl(room);
  const dialInInfoBlock = includeDialIn
    ? `
    🌐 Looking for a different dial-in number in your area?<br>
    <a href="${dialInInfoUrl}">
      ${dialInInfoUrl}
    </a><br>
  `
    : '';

  return `${computerBlock}${dialInBlock}${dialInInfoBlock}`;
}

export function copyInvitationText(
  room: string,
  options?: GetMeetingInvitationOptions,
  password?: string,
): string {
  const { phoneNumber, pin, hasLicenseError } = options ?? {};

  const hasDialIn = !!phoneNumber || !!pin;
  const includeDialIn = hasDialIn && !hasLicenseError;

  const computerBlock = `
    🖥️ Join this meeting from your computer or mobile device:
    ${getMeetingUrl(room || '', password)}
  `;

  const passwordBlock = includeDialIn && password ? ` | Password: ${password || ''}` : '';

  const dialInBlock = includeDialIn
    ? `
    📞 Want to join using a phone?
    Dial-in: ${phoneNumber || ''} | PIN: ${formatPin(pin || '')}${passwordBlock}
    [ tel:${formatPhoneNumberForTel(phoneNumber || '')},${formatPinForTel(pin || '')} ]
  `
    : '';

  const dialInInfoUrl = getDialInNumbersUrl(room);
  const dialInInfoBlock = includeDialIn
    ? `
    🌐 Looking for a different dial-in number in your area?
    ${dialInInfoUrl}
  `
    : '';

  return `${computerBlock}${dialInBlock}${dialInInfoBlock}`;
}
